var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "UI / Icon / Password-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-/-Icon-/-Password-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounds",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    stroke: "#333333",
    fillRule: "nonzero",
    x: 4.5,
    y: 8.5,
    width: 13,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    fill: "#333333",
    fillRule: "nonzero",
    x: 10.5,
    y: 13,
    width: 1,
    height: 3,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    fill: "#333333",
    fillRule: "nonzero",
    x: 10,
    y: 12,
    width: 2,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,8.5 L14.5,8.5 L14.5,5 C14.5,3.61928813 13.3807119,2.5 12,2.5 L10,2.5 C8.61928813,2.5 7.5,3.61928813 7.5,5 L7.5,8.5 Z",
    id: "Shape",
    stroke: "#333333",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword1);
export default __webpack_public_path__ + "static/media/password1.919bde5b7640e1e46aa4cbbf3bfafa26.svg";
export { ForwardRef as ReactComponent };